var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Login via url")]),_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }